import React from 'react';
import { Box, Typography } from '@mui/material';

interface OperationTypeProps {
  isPlanned: boolean;
  isEmergency: boolean;
}

const OperationType: React.FC<OperationTypeProps> = ({ isPlanned, isEmergency }) => {
  const getOperationTypeText = () => {
    const types: string[] = [];

    if (isPlanned) {
      types.push('Planned');
    }

    if (isEmergency) {
      types.push('Emergency');
    }

    return types.join(', ');
  };

  return (
    <Box>
      <Typography variant="caption" sx={{
        color: "text.primary"
      }}>
        Type of Operation
      </Typography>
      <Typography variant="body1">
        {getOperationTypeText()}
      </Typography>
    </Box>
  );
};

export default OperationType;